<template>
  <footer class="footer">
    <div class="container">
      <a :href="marketingSiteUrl" class="footer__logo">
        <img :src="logo" alt="logo" />
      </a>

      <div class="footer__menu" v-if="showLinks">
        <div v-for="group in footerLinks" :key="group.title">
          <div class="footer__menu__title">{{ group.title }}</div>
          <ul>
            <li v-for="link in group.children" :key="link.label">
              <a :href="link.href">{{ link.label }}</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer__links">
        <footer-social-media
          instagramUrl="https://www.instagram.com/aqua_expeditions"
          twitterUrl="https://www.twitter.com/AquaExpeditions"
          facebookUrl="https://www.facebook.com/pages/Aqua-Expeditions/71422947695"
        />

        <div class="footer__links-copyright">
          <a :href="`${marketingSiteUrl}/copyright`">
            Copyright&nbsp;©&nbsp;Aqua&nbsp;Expeditions<!-- --></a
          >{{ " " }} ·&nbsp;<span>All&nbsp;Rights&nbsp;Reserved</span> ·&nbsp;<a
            :href="`${marketingSiteUrl}/booking-policies`"
            >Terms&nbsp;&amp;&nbsp;Conditions</a
          >
          ·&nbsp;<a :href="`${marketingSiteUrl}/privacy-policy`"
            >Privacy&nbsp;Policy</a
          >
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import FooterSocialMedia from "./FooterSocialMedia.vue";

export default {
  name: "Footer",
  components: { FooterSocialMedia },
  props: {
    showLinks: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const marketingSiteUrl = process.env.MARKETING_SITE_FRONTEND_URL;
    return {
      logo: require("../../assets/images/logo.svg"),
      footerLinks: [
        {
          title: "Destinations",
          children: [
            {
              label: "Vietnam and Cambodia: Mekong River",
              href: `${marketingSiteUrl}/destinations/mekong-river-cruise`,
            },
            {
              label: "Peru: Amazon River",
              href: `${marketingSiteUrl}/destinations/amazon-river-cruise`,
            },
            {
              label: "Galapagos Islands",
              href: `${marketingSiteUrl}/destinations/galapagos-cruise`,
            },
            {
              label: "Indonesia",
              href: `${marketingSiteUrl}/multiple-destinations/indonesia-cruise`,
            },
            {
              label: "Bali - Komodo National Park",
              href: `${marketingSiteUrl}/destinations/indonesia-cruise/bali-komodo-national-park`,
            },
            {
              label: "Ambon & Spice Islands",
              href: `${marketingSiteUrl}/destinations/indonesia-cruise/ambon-and-spice-islands`,
            },
            {
              label: "Raja Ampat",
              href: `${marketingSiteUrl}/destinations/indonesia-cruise/raja-ampat-cruise`,
            },
            {
              label: "Asmat & New Guinea",
              href: `${marketingSiteUrl}/destinations/indonesia-cruise/asmat-new-guinea`,
            },
            {
              label: "Dual Destination",
              href: `${marketingSiteUrl}/destinations/indonesia-cruise/dual-destinations`,
            },
          ],
        },
        {
          title: "Cruise ships",
          children: [
            {
              label: "Aqua Mekong",
              href: `${marketingSiteUrl}/cruise-ships/aqua-mekong`,
            },
            {
              label: "Aria Amazon",
              href: `${marketingSiteUrl}/cruise-ships/aria-amazon`,
            },
            {
              label: "Aqua Nera",
              href: `${marketingSiteUrl}/cruise-ships/aqua-nera`,
            },
            {
              label: "Aqua Blu",
              href: `${marketingSiteUrl}/cruise-ships/aqua-blu`,
            },
            {
              label: "Aqua Mare",
              href: `${marketingSiteUrl}/cruise-ships/aqua-mare`,
            },
            {
              label: "Private charters",
              href: `${marketingSiteUrl}/private-charter-cruises`,
            },
          ],
        },
        {
          title: "Offers & Events",
          children: [
            // {
            //   label: '20% Indonesia Summer Special',
            //   href: `${marketingSiteUrl}/events/indonesia-summar-special`,
            // },
            {
              label: "20-30% Early Bird Bonus",
              href: `${marketingSiteUrl}/offers/early-bird-bonus`,
            },
            {
              label: "25% Local Resident Offer",
              href: `${marketingSiteUrl}/offers/local-resident`,
            },
            {
              label: "Solo Traveler Special",
              href: `${marketingSiteUrl}/offers/solo-traveler-special`,
            },
            {
              label: "Aqua Blu - Chef Benjamin Cross",
              href: `${marketingSiteUrl}/offers/chef-hosted-cruise-benjamin-cross`,
            },
            {
              label: "Aqua Nera - Chef Pedro Miguel Schiaffino",
              href: `${marketingSiteUrl}/offers/chef-hosted-cruises-pedro-miguel-schiaffino`,
            },
          ],
        },
        {
          title: "Company",
          children: [
            {
              label: "Our Experience",
              href: `${marketingSiteUrl}/aqua-experience`,
            },
            { label: "Blog", href: `${marketingSiteUrl}/blog` },
            { label: "Brochure", href: `${marketingSiteUrl}/brochures` },
            { label: "Contact Us", href: `${marketingSiteUrl}/contact-us` },
            { label: "Career", href: `${marketingSiteUrl}/careers` },
          ],
        },
      ],
      marketingSiteUrl,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../../scss/color.scss";
@import "../../scss/typography.scss";
@import "../../scss/mixin.scss";

.footer {
  background-color: $aqua-grey-100;

  @include lg {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  &__logo {
    @include lg-down {
      display: none;
    }
  }

  &__menu {
    @include lg-down {
      display: none;
    }

    @include lg {
      margin-top: 5rem;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 1.5rem;
    }

    &__title {
      margin-bottom: 1rem;
      color: $aqua-grey-50;
      font-family: "century-gothic", serif;
      font-size: 14px;
      line-height: 22px; /* 157.143% */
    }

    ul {
      padding: 0;
      list-style: none;

      > li {
        > a {
          color: #fff;
          font-family: "century-gothic", serif;
          font-size: 14px;
          line-height: 22px;
          text-decoration: none;
        }

        + li {
          margin-top: 1rem;
        }
      }
    }
  }

  &__bottom {
  }

  &__links {
    display: flex;
    flex-direction: column;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    gap: 2.5rem;

    @include lg {
      flex-direction: row;
      justify-content: space-between;
      margin-top: 5rem;
      padding: 0;
    }

    &-copyright {
      font-family: "century-gothic", serif;
      font-size: 0.75rem;
      line-height: 1.5rem;
      letter-spacing: 0.015rem;
      color: $aqua-grey-75;
      text-align: center;
      max-width: 21.4375rem;
      align-self: center;

      @include lg {
        max-width: none;
        align-self: flex-end;
      }
    }

    a {
      text-decoration: underline;
    }

    a:link,
    a:visited {
      color: $aqua-grey-75;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Footer.vue